import { isNumber, isString, upperCamelCase } from '@art-suite/art-core-ts';

/**
 * Presents a flooring-area value name without its "Area" suffix, human-friendly:
 * "hardwoodArea" -> "Hardwood", "tileArea" -> "Tile"
 */
export const flooringAreaValueNamePresenter = (valueName: string): string => upperCamelCase(valueName.replace(/Area$/, '') || valueName, ' ');

export const formatUsd = (value?: any, roundUpToNearestDollar = false, showZero = false): string => {
  if (!value) return showZero ? (roundUpToNearestDollar ? '$0' : '$0.00') : '$--';
  if (isString(value)) value = parseFloat(value);
  else if (!isNumber(value)) return '$--';
  if (isNaN(value)) return '$--';
  if (roundUpToNearestDollar) {
    return `$${Math.ceil(value).toLocaleString('en-US')}`;
  }
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const normalizeProjectType = (projectType?: string | null) => {
  if (!projectType) return 'turn';
  const normalized = projectType.trim().toLowerCase();
  return normalized === 'legacy' ? 'turn' : normalized;
};

export const formatProjectTypeLabel = (projectType?: string | null) => {
  if (!projectType?.trim()) return 'Turn';
  if (projectType.trim().toLowerCase() === 'legacy') return 'Turn';

  return projectType
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, character => character.toUpperCase());
};
